import React from 'react';
import { getDietQualityColor } from '../../../lib/themes/generalTheme';

export const getChipColor = (name) => {
  switch (name.toLowerCase()) {
    case 'carbohydrates':
      return getDietQualityColor(5);
    case 'total fat':
      return getDietQualityColor(7);
    case 'protein':
      return getDietQualityColor(9);
    default:
      return 'transparent';
  }
};

export const getChipStyles = (name) => ({
  backgroundColor: getChipColor(name),
  '& .MuiChip-label': {
    overflow: 'visible',
    textOverflow: 'unset',
    whiteSpace: 'normal',
  },
});
